import { END_POINTS } from "../constants/urls";
import { CommonBody, CommonResponseType } from "../types/General";
import emptySplitApi from "../utils/rtk";

export const manageReviewsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getManageReviews: builder.query<
      CommonResponseType & { data: any },
      { page: number; limit: number; status: number; search: string }
    >({
      query: ({ page, limit, status, search }) => ({
        url: `${END_POINTS.getManageReviews}?page=${page}&limit=${limit}&status=${status}&search=${search}`,
        method: "GET",
      }),
    }),
    getReviewbyId: builder.query<
      CommonResponseType & { data: any },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getReviewbyId}/${id}`,
        method: "GET",
      }),
    }),
    deleteReview: builder.query<
      CommonResponseType & { data: any },
      { id: any }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteReview}/${id}`,
        method: "DELETE",
      }),
    }),

    updateReview: builder.mutation<
      CommonResponseType & { data: any },
      { id: any; body: any }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.updateReview}/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetManageReviewsQuery,
  useLazyGetReviewbyIdQuery,
  useLazyDeleteReviewQuery,
  useUpdateReviewMutation,
} = manageReviewsApi;
